export default __webpack_public_path__ + "static/media/Banner Consejo de Cultura.f102e705.png";